import React from 'react';
import AddendumRow, { sortAddendaNewestFirst } from './AddendumRow';
import { API_BASE_URL } from '../../utils/api';

/**
 * The addenda already filed on a QC record, read from the WORKFLOW side
 * (docs/modules/workflow-qcad.md §5) — the New page (before writing the next
 * one), the QCAD detail page (the reviewer reads this addendum against the
 * revisions before it) and the read-only record page. One list, one gate:
 * PDFs and files go through /api/workflow/qcad/record/:id/…, which any
 * caller who may read the record may use (no Management key).
 *
 *   record     the parent QC record (header rows of each addendum)
 *   addenda    every addendum of the record (server order or not — sorted here)
 *   excludeId  drop this addendum (the request's own on the detail page)
 *   emptyText  what to print when nothing is left to list
 */
const WorkflowAddendaList = ({ record, addenda, excludeId = null, emptyText = 'No addendum has been filed on this record yet.' }) => {
  const list = sortAddendaNewestFirst((addenda || []).filter((a) => a.id !== excludeId));
  if (list.length === 0) return <p className="text-sm text-slate-500">{emptyText}</p>;
  const base = `${API_BASE_URL}/api/workflow/qcad/record/${record.id}/addenda`;
  return (
    <div className="space-y-2">
      {list.map((a, i) => (
        <AddendumRow
          key={a.id}
          addendum={a}
          record={record}
          latest={i === 0}
          pdfHref={`${base}/${a.id}/pdf`}
          fileHref={(f) => `${base}/${a.id}/files/${f.id}`}
        />
      ))}
    </div>
  );
};

export default WorkflowAddendaList;
